import { fmtNum } from "../lib/format";
import { fmtDur, pctChange } from "../lib/pickerSheet";

const METRICS = [
  ["vph", "Visits / hr", fmtNum, false],
  ["qph", "Qty / hr", fmtNum, false],
  ["lostDay", "Lost / day", fmtDur, true],
  ["visits", "Visits", fmtNum, false],
  ["qty", "Qty", fmtNum, false],
  ["hrs", "Hours", fmtNum, false],
  ["days", "Days worked", fmtNum, false],
  ["absent", "Absent days", fmtNum, true],
];

const RATES = new Set(["vph", "qph", "lostDay"]);

const Pct = ({ v, inverse, testId }) => {
  if (v == null) return <span className="block text-[10px] text-slate-600" data-testid={testId}>—</span>;
  const good = inverse ? v <= 0 : v >= 0;
  return <span data-testid={testId} className={`block text-[10px] ${good ? "text-emerald-400" : "text-rose-400"}`}>{v >= 0 ? "▲" : "▼"} {Math.abs(v).toFixed(1)}%</span>;
};

export const QuarterCompare = ({ quarters, hasQty }) => {
  const metrics = METRICS.filter(([k]) => hasQty || (k !== "qty" && k !== "qph"));
  const full = quarters.filter((q) => q.months === 3);
  const a = full[0], b = full[full.length - 1];
  return (
    <div data-testid="quarter-compare">
      <div className="overflow-x-auto">
        <table className="w-full text-xs font-mono">
          <thead><tr className="text-slate-500 border-b border-slate-800">
            <th className="text-left py-2">Quarter</th>
            {metrics.map(([k, l]) => <th key={k} className="text-right py-2 pl-3 font-medium whitespace-nowrap">{l}</th>)}
          </tr></thead>
          <tbody>
            {quarters.map((q, i) => (
              <tr key={q.key} className="border-b border-slate-800/50 align-top" data-testid={`quarter-row-${q.key.replaceAll(" ", "-")}`}>
                <td className="py-1.5 text-slate-300 whitespace-nowrap">{q.key}{q.months < 3 && <span className="ml-1 text-[9px] text-amber-400" title="Partial quarter">({q.months} mo)</span>}</td>
                {metrics.map(([k, , f, inv]) => (
                  <td key={k} className="text-right py-1.5 pl-3 whitespace-nowrap text-slate-200">
                    {q[k] == null ? "—" : f(q[k])}
                    <Pct v={i && (RATES.has(k) || (q.months === 3 && quarters[i - 1].months === 3)) ? pctChange(q[k], quarters[i - 1][k]) : null} inverse={inv} testId={`q-${q.key.replaceAll(" ", "-")}-${k}-pct`} />
                  </td>
                ))}
              </tr>
            ))}
            {a && b && a !== b && (
              <tr className="bg-[#0B0F19]" data-testid="quarter-overall-row">
                <td className="py-2 text-slate-100 font-semibold whitespace-nowrap">{a.key} → {b.key}</td>
                {metrics.map(([k, , , inv]) => <td key={k} className="text-right py-2 pl-3"><Pct v={pctChange(b[k], a[k])} inverse={inv} testId={`q-overall-${k}-pct`} /></td>)}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <p className="text-[10px] text-slate-500 mt-2">% vs previous quarter. Green = better (more output per hour, less lost time / absence). Bottom row compares first and latest full quarters. Partial quarters are marked; for them only the per-hour and per-day rates are compared.</p>
    </div>
  );
};
